import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {isPublicView} from "../../app.module";
import {ActAsUserLocalStorageService} from "../services/local-storage-services/impl/act-as-user.local-storage-service";
import {AuthHeaderNames} from "@common-module/modelinterfaces/enums/auth-header-names";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private readonly EXCLUDE_JSON_CONTENT = [
    new RegExp(/ecoDrivingCriterion\/unit\/\d+\/import/),
    /jobImport\/parse/,
    /logisticRoute\/\d+\/download/,
    /customPlanImport\/parse/,
    /geofence\/import\/kml\/parse/,
  ];

  constructor(private readonly actAsLocalStorage: ActAsUserLocalStorageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      setHeaders: this.setHeaders(req)
    });

    return next.handle(req);
  }

  private setHeaders(req: HttpRequest<any>): { [p: string]: string | string[] } {
    const reqUrl = req.url;

    if (isPublicView()) {
      const publicKey: string = this.getPublicKey();
      return {
        'Content-Type': 'application/json',
        'publicKey': publicKey || ''
      };
    }

    const headers: Record<string, string> = {};

    const hasActAsHeader = req.headers.has(AuthHeaderNames.ACT_AS);
    const actAsUserId = this.actAsLocalStorage.get();

    // если хедер уже был установлен в сервисе здесь не подменяем
    if (!hasActAsHeader && actAsUserId) {
      headers[AuthHeaderNames.ACT_AS] = String(actAsUserId);
    }

    // Content-Type ставим только если урл не в исключениях
    if (!this.EXCLUDE_JSON_CONTENT.some(pattern => pattern.test(reqUrl))) {
      headers['Content-Type'] = 'application/json';
    }

    return headers;
  }

  // получаем из window потому что сервис UnitGroupsService инициализируется в
  // AppModule на стадии APP_INITIALIZER на этой стадии Router не доступен
  getPublicKey(): string {
    let url = new URL(window.location.href.toLowerCase());
    return url.searchParams.get('publickey')
  }
}
